<template>
  <div>
    <el-dialog title="选择客户" :visible.sync="isCustomer" :before-close="handleClose" width="1000px" center class="dialogCustomer">
      <div class="display" style="margin-bottom: 20px;">
        <el-input clearable  style="width: 300px;margin-right: 12px;" v-model="customerQuery.keyword" placeholder="请输入关键字"
          @keyup.enter.native="customerSearchList"></el-input>
        <el-button type="primary" @click="customerSearchList()">搜索</el-button>
        <el-button type="primary" @click="add(dataCustomer)" v-if="currentCustomer">{{currentCustomer}}</el-button>
      </div>
      <el-table :data="customerData" max-height="430" v-loading="customerLoading">
        <el-table-column label="客户全称" property="fullname" min-width="180" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="short_name" label="客户简称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="level_name" label="客户等级"></el-table-column>
        <el-table-column property="follow_up_person" label="所属业务员"></el-table-column>
        <el-table-column label="操作" min-width="50">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="add(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="pagination-container">
        <el-pagination
          class="paginationClass"
          @size-change="customerSizeChange"
          @current-change="customerCurrentChange"
          layout="total, sizes,prev, pager, next,jumper"
          :current-page.sync="customerQuery.page"
          :page-size="customerQuery.limit"
          :page-sizes="[10,20,50,100,200]"
          :total="customerTotal">
        </el-pagination>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
  import {getList as customerList} from '@/api/customer'

  var ls = window.localStorage;
  const defaultCustomerQuery = {
    // page: 1,
    // limit: 20,
    keyword:null,
  };
  export default {
    props: {
      dialogCustomer: { // 父组件传递过来的表头数据
        type: Boolean,
        default(){
          return false
        }
      },
    },
    data() {
      return {
        customerQuery: Object.assign({}, defaultCustomerQuery),
        isCustomer:this.dialogCustomer,
        customerLoading:false,
        customerData:[],
        customerTotal:0,
        currentCustomer:ls.getItem('nibd_customerName')?ls.getItem('nibd_customerName'):null,
        dataCustomer:{
          partner_id:ls.getItem('nibd_partner_id')
        }
      }
    },
    watch:{
      dialogCustomer(val){
        this.isCustomer = val
        this.currentCustomer = ls.getItem('nibd_customerName')
        this.dataCustomer.partner_id = ls.getItem('nibd_partner_id')
      },
    },
    created() {
      this.getCustomerList()
    },
    methods: {
      // 获取客户列表
      getCustomerList(){
        this.customerLoading = true;
        customerList(this.customerQuery).then(res => {
          this.customerLoading = false;
          if (res.data.data) {
            this.customerData = res.data.data.data
            this.customerTotal = res.data.data.total
          }
        })
      },
      customerSearchList(){
        // this.customerQuery.page = 1;
        this.getCustomerList();
      },
      // customerSizeChange(val) {
      //   this.customerQuery.page = 1;
      //   this.customerQuery.limit = val;
      //   this.getCustomerList();
      // },
      // customerCurrentChange(val) {
      //   this.customerQuery.page = val;
      //   this.getCustomerList();
      // },
      add(row){
        this.$emit('click',row)
      },
      handleClose(){
        this.$emit('handleClose')
      },
    }
  }
</script>

<style scoped>
  .dialogCustomer /deep/ .el-dialog__body{
    padding: 15px 25px 15px;
  }
  .pagination-container{
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/customerSelect/index.vue